import { Save } from "lucide-react";
import { Button } from "../ui/controls";

export function DraftSaveButton({ dirty, pending, blocked, onSave }: { dirty: boolean; pending: boolean; blocked: boolean; onSave: () => void }) {
  return <Button onClick={onSave} disabled={pending || !dirty || blocked}>
    <Save size={17} />{pending ? "Kaydediliyor…" : dirty ? "Taslağı kaydet" : "Taslak kayıtlı"}
  </Button>;
}
